<template>
  <div>
    <!-- display toggle -->
    <div v-show="!isExpanded" class="flex flex-justify-center welcome-message">
      <button
        class="btn -link-reverse"
        :aria-expanded="isExpanded.toString()"
        aria-controls="aria-welcome"
        @click.prevent="toggleExpanded"
      >
        {{ ctaText }} <span class="iconfont-play" role="img" aria-label="Play" />
      </button>
    </div>

    <!-- display welcome video -->
    <div v-show="isExpanded" id="aria-welcome" class="show-header fbp-welcome">
      <div class="container -flush">
        <div class="media">
          <div ref="videoEmbed"></div>
        </div>
        <div class="info">
          <div class="container -flush -flex flex-justify-end">
            <button class="close-welcome" aria-label="Close" @click.prevent="toggleExpanded">
              <i class="material-symbols-outlined btn-ico close" aria-hidden="true">close</i>
            </button>
          </div>
          <div class="video-details">
            <h2 class="heading -x-small caps-half demi details">
              {{ title }}
            </h2>
            <p class="stats demi">
              {{ description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { useUserAuthStore } from '@/stores/user-auth'
import brightcovePlayerLoader from '@brightcove/player-loader'

export default defineComponent({
  name: 'VideoExpandableCallout',
  components: {},
  props: {
    initialExpanded: {
      type: Boolean,
      default: false,
    },

    // player / video props
    videoId: {
      type: String,
      required: true,
    },

    // content props
    ctaText: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
  },
  emits: ['video-expand-action'],
  data() {
    return {
      isExpanded: this.initialExpanded,
    }
  },
  computed: {
    // account id and player id from window.Laravel via pinia
    ...mapState(useUserAuthStore, ['videoPlayer']),
  },
  mounted() {
    // load video if expanded only
    if (this.isExpanded) {
      this.loadVideo()
    }
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded

      // load video if expanded only
      if (this.isExpanded) {
        this.loadVideo()
      } else {
        // clear inner html so video can load again
        this.$refs.videoEmbed.innerHTML = ''
      }

      // event emitting to parent can do an action
      this.$emit('video-expand-action', this.isExpanded)
    },

    loadVideo() {
      brightcovePlayerLoader({
        refNode: this.$refs.videoEmbed,
        refNodeInsert: 'append',
        accountId: this.videoPlayer.accountId,
        playerId: this.videoPlayer.playerId,
        embedId: 'default',
        videoId: this.videoId,
        embedOptions: {
          responsive: true,
        },
      })
    },
  },
})
</script>
